import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const vuexStore = new Vuex.Store({
  state: {
    self: {},
    team: {},
    applicant_id: null,
    r_form: {},
    form: {},
    interviews: [],
    selectTeam: false,
    isSpecialTips: false
  },
  mutations: {
    set_self(state, self) {
      state.self = self;
    },
    set_team(state, team) {
      state.team = team;
    },
    set_form1(state, team) {
      state.form = team;
    },
    set_form(state, data) {
      state.r_form = data;
    },
    set_interviews(state, data) {
      state.interviews = data;
    },
    set_applicant_id(state, data) {
      state.applicant_id = data;
    },
    selectTeamChange(state, data) {
      state.selectTeam = data;
    },
    setSpecialTips(state, data) {
      state.isSpecialTips = data;
    }
  },
  actions: {},
  modules: {}
});
export default vuexStore;
